import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-order-create-labels',
  templateUrl: './order-create-labels.component.html',
  styleUrls: ['./order-create-labels.component.scss']
})
export class OrderCreateLabelsComponent implements OnInit {

  @Input()
  navLabels: string[] = [];

  @Input()
  activeIndex: number = 0;

  constructor() { }

  ngOnInit() {
  }

}
